// @flow
export const API_GENERAL: 'general' = 'general';
export const API_SHOP: 'shop' = 'shop';
export const API_ELJUR: 'eljur' = 'eljur';
export const API_WS: 'ws' = 'ws';
